<script>
import moment from 'moment'
import {
  rexRoundedAutocomplete,
  rexRoundedSingleSelect
} from '@/components/views/rexRoundedField'
import {
  formatThousands
} from '@/utils/helpers'
import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'
import removeIcon from '@/assets/images/icons/cancel.svg?inline'
import ExcursionModalInfo from './ExcursionModalInfo.vue'

export default {
  name: 'excursion-form',
  components: {
    rexRoundedAutocomplete,
    rexRoundedSingleSelect,
    PopupPenalties,
    ExcursionModalInfo,
    removeIcon,
  },
  props: {
    formIsShown: {
      type: Boolean,
      default: () => true
    },
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    excursionIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    type: [
      {
        name: 'Все',
        slug: null,
      },
      {
        name: 'Пешеходная',
        slug: 'walk',
      },
      {
        name: 'Автомобильная',
        slug: 'bycar',
      },
    ],
    goType: [
      {
        name: 'Все',
        slug: null,
      },
      {
        name: 'Групповая',
        slug: 'group',
      },
      {
        name: 'Индивидуальная',
        slug: 'individual',
      }
    ]
  }),
  computed: {
    getDates() {
      return this.$store.getters['cart/getDates']
    },
    getCityTo() {
      return this.$store.getters['cart/getLocations'].cityTo
    },
    currency() {
      return this.$store.getters['cart/getCartPrice'].currency
    },
    getExcursion() {
      return this.$store.getters['cart/getExcursion'](this.excursionIndex)
    },
    getExcursionForm() {
      return this.$store.getters['cart/getExcursionForm'](this.excursionIndex)
    },
    selectedExcursions() {
      return this.$store.getters['cart/getExcursionsSelected'](this.excursionIndex)
    },
  },
  watch: {
    getDates: {
      // eslint-disable-next-line
      handler: function () {
        this.setExcursionDates(this.getDates)
      },
      deep: true
    }
  },
  created() {
    this.setExcursionDates(this.getDates)

    if (this.getCityTo.slug) {
      this.$store.commit('cart/updateServiceField', {
        target: `excursions.${this.excursionIndex}.form.city`,
        value: this.getCityTo
      })
    }
  },
  methods: {
    search() {
      this.$parent.formIsShown = false
      this.$parent.resultIsShown = true

      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `excursions.${this.excursionIndex}.excursions`
      })

      this.$store.dispatch('cart/getExcursions', {
        excursionIndex: this.excursionIndex,
        form: {
          ...this.$store.getters['cart/getExcursionFormForSearch'](this.excursionIndex)

        }
      })
    },
    penaltiesData(index) {
      return {
        ...this.$store.getters['cart/getExcursionPenaltiesData']({
          excursionIndex: this.excursionIndex,
          index
        }),
        currency: this.currency
      }
    },
    mapCollection(collection) {
      return collection.map(item => ({
        slug: item.slug,
        name: item.name
      }))
    },
    mapCollectionVariants(excursion) {
      return excursion.prices.map((item, index) => ({
        slug: index,
        name: `${moment.unix(item.from).format('HH:mm DD.MM')} (+${formatThousands(item.price.amount)} ${item.price.currency})`
      }))
    },
    deleteSelectedExcursion(index) {
      this.$store.commit('cart/deleteSelectedExcursion', {
        excursionIndex: this.excursionIndex,
        index
      })
    },
    select(index) {
      this.$store.commit('cart/removeServiceFromAllPenalties', {
        service: 'excursions',
        serviceId: `${this.getExcursion.searchId}_${this.excursionIndex}_${index}`
      })

      this.$store.dispatch('cart/getServicePenaltiesForAll', {
        ids: this.penaltiesData(index),
        serviceName: 'excursions',
        serviceId: `${this.getExcursion.searchId}_${this.excursionIndex}_${index}`,
        apiModuleName: 'excursions',
        label: `Экскурсия: ${this.selectedExcursions[index].current.name}`
      })
    },
    setExcursionDates({ startDate, endDate }) {
      this.$store.commit('cart/updateServiceField', {
        target: `excursions.${this.excursionIndex}.form.dateFrom`,
        value: startDate
      })

      this.$store.commit('cart/updateServiceField', {
        target: `excursions.${this.excursionIndex}.form.dateTo`,
        value: endDate
      })
    },
  }
}

</script>
<template>
  <div class="cart__excursions">
    <div class="cart__excursions-form--content full-width">
      <div v-if="resultIsShown">
        <div
          v-for="(item, index) in selectedExcursions"
          :key="index"
          class="cart__search-form--row"
        >
          <rex-rounded-single-select
            label="Тип"
            :show-label="index === 0"
            store-module="cart"
            getter-name="getServiceField"
            setter-name="updateServiceField"
            :target="`excursions.${excursionIndex}.selected.${index}.goType`"
            class="cart__search-form--select-excursion-type"
            :disabled="true"
            :data="goType"
          />
          <rex-rounded-single-select
            label="Группа"
            :show-label="index === 0"
            store-module="cart"
            getter-name="getServiceField"
            setter-name="updateServiceField"
            :target="`excursions.${excursionIndex}.selected.${index}.type`"
            class="cart__search-form--select-excursion-type"
            :disabled="resultIsShown"
            :data="type"
          />
          <rex-rounded-single-select
            label="Экскурсия"
            :show-label="index === 0"
            store-module="cart"
            getter-name="getExcursionSelectedCurrent"
            setter-name="updateSelectedCurrent"
            class="cart__search-form--select-excursion"
            :target="`excursions.${excursionIndex}.selected.${index}`"
            :data="mapCollection(item.collection)"
            @onChange="select(index)"
          />
          <rex-rounded-single-select
            label="Дата и время"
            :show-label="index === 0"
            store-module="cart"
            getter-name="getExcursionSelectedPriceIndex"
            setter-name="updateServiceField"
            class="cart__search-form--select-excursion-plan"
            :target="`excursions.${excursionIndex}.selected.${index}.priceIndex`"
            :data="mapCollectionVariants(item)"
            @onChange="select(index)"
          />
          <div
            v-if="resultIsShown"
            class="cart__excursions-form--buttons"
          >
            <popup-penalties
              v-if="resultIsShown"
              :ids="penaltiesData(index)"
              store-module="cart"
              service-name="excursions"
              :target="`excursions.${excursionIndex}`"
              api-module-name="excursions"
              :wrapper-class="`cart__search-form--remove-btn ${index === 0 ? 'bottom-btn' : ''}`"
            />
            <div
              class="cart__search-form--remove-btn"
              :class="{
                'bottom-btn': index === 0
              }"
            >
              <excursion-modal-info
                :excursion-data="{
                  excursionSearchId: getExcursion.searchId,
                  excursionId: item.current.slug,
                  currency: currency
                }"
                :excursion-index="excursionIndex"
              />
            </div>
            <div
              class="cart__search-form--remove-btn"
              :class="{
                'bottom-btn': index === 0
              }"
            >
              <removeIcon
                fill="#55b7a1"
                @click="deleteSelectedExcursion(index)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="selectedExcursions.length < getDates.duration"
        class="cart__search-form--row"
      >
        <rex-rounded-single-select
          label="Тип"
          :show-label="!(resultIsShown && selectedExcursions.length)"
          store-module="cart"
          getter-name="getServiceField"
          setter-name="updateServiceField"
          :target="`excursions.${excursionIndex}.form.goType`"
          class="cart__search-form--select-excursion-type"
          :data="goType"
        />
        <rex-rounded-single-select
          label="Группа"
          :show-label="!(resultIsShown && selectedExcursions.length)"
          store-module="cart"
          getter-name="getServiceField"
          setter-name="updateServiceField"
          :target="`excursions.${excursionIndex}.form.type`"
          class="cart__search-form--select-excursion-type"
          :data="type"
        />
        <div
          class="cart__excursions-form-control"
          :class="{
            'cart__excursions-form-control--no-label': resultIsShown && selectedExcursions.length
          }"
        >
          <button
            class="rex-btn-main rex-btn-main--h40"
            @click="search"
          >
            Найти
          </button>
        </div>
      </div>
      <div
        v-if="!getCityTo.slug"
        class="cart__search-form--row"
      >
        <rex-rounded-autocomplete
          label="Укажите место проживания"
          store-module="cart"
          getter-name="getServiceField"
          setter-name="updateServiceField"
          :target="`excursions.${excursionIndex}.form.city`"
          css-class="cart__search-form--w100"
          endpoint="excursionsPlaces"
        />
      </div>
    </div>
  </div>
</template>